import React from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';

/**
 * StudentNavigation Component
 * 
 * Renders the main navigation menu with dropdown options for:
 * - Student Details
 * - Student Forms (with dropdown)
 * - Student Log (with dropdown)
 * - Academics (with dropdown)
 * - Certificates and Other (with dropdown)
 * - Finance
 * - Library
 * - Documents
 * - Add Appointment
 * - Concerns
 * - Access Restriction
 * - Student Profile Album
 */
export const StudentNavigation = ({ 
    activeMenu,
    menuItems,
    studentFormsMenuRef,
    studentLogMenuRef,
    academicsMenuRef,
    certificatesMenuRef,
    onMenuClick,
    onDropdownMenuClick
}) => {
    return (
        <div className="student-navigation-menu mt-5">
            <div className="menu-items">
                <div className="menu-item">
                    <Button
                        label="Student Details"
                        className={`p-button-text menu-button ${activeMenu === 'studentDetails' ? 'active' : ''}`}
                        onClick={() => onMenuClick({ 
                            activeMenu: 'studentDetails', 
                            showStudentDetailsView: true, 
                            showFinanceView: false,
                            activeDetailView: 'personalInfo', 
                            activeSubMenu: 'personalInfo' 
                        })}
                    />
                </div>

                <div className="menu-item">
                    <Button
                        label="Student Forms"
                        icon="pi pi-chevron-down"
                        iconPos="right"
                        className={`p-button-text menu-button ${activeMenu === 'studentForms' ? 'active' : ''}`}
                        onClick={(e) => {
                            onDropdownMenuClick();
                            studentFormsMenuRef.current.toggle(e);
                        }}
                    />
                    <Menu model={menuItems.studentForms} popup ref={studentFormsMenuRef} />
                </div>

                <div className="menu-item">
                    <Button
                        label="Student log"
                        icon="pi pi-chevron-down"
                        iconPos="right"
                        className={`p-button-text menu-button ${activeMenu === 'studentLog' ? 'active' : ''}`}
                        onClick={(e) => {
                            onDropdownMenuClick();
                            studentLogMenuRef.current.toggle(e);
                        }}
                    />
                    <Menu model={menuItems.studentLog} popup ref={studentLogMenuRef} />
                </div>

                <div className="menu-item">
                    <Button
                        label="Academics"
                        icon="pi pi-chevron-down"
                        iconPos="right"
                        className={`p-button-text menu-button ${activeMenu === 'academics' ? 'active' : ''}`}
                        onClick={(e) => {
                            onDropdownMenuClick();
                            academicsMenuRef.current.toggle(e);
                        }}
                    />
                    <Menu model={menuItems.academics} popup ref={academicsMenuRef} />
                </div>

                <div className="menu-item">
                    <Button
                        label="Certificates and Other"
                        icon="pi pi-chevron-down"
                        iconPos="right"
                        className={`p-button-text menu-button ${activeMenu === 'certificates' ? 'active' : ''}`}
                        onClick={(e) => {
                            onDropdownMenuClick();
                            certificatesMenuRef.current.toggle(e);
                        }}
                    />
                    <Menu model={menuItems.certificates} popup ref={certificatesMenuRef} />
                </div>

                <div className="menu-item">
                    <Button
                        label="Finance"
                        className={`p-button-text menu-button ${activeMenu === 'finance' ? 'active' : ''}`}
                        onClick={() => onMenuClick({ 
                            activeMenu: 'finance', 
                            showFinanceView: true, 
                            showStudentDetailsView: false,
                            activeFinanceView: 'feeDetails', 
                            activeSubMenu: 'feeDetails' 
                        })}
                    />
                </div>

                <div className="menu-item">
                    <Button
                        label="Library"
                        className={`p-button-text menu-button ${activeMenu === 'library' ? 'active' : ''}`}
                        onClick={() => onMenuClick({ 
                            activeMenu: 'library', 
                            showFinanceView: false, 
                            showStudentDetailsView: false 
                        })}
                    />
                </div>

                <div className="menu-item">
                    <Button
                        label="Documents"
                        className={`p-button-text menu-button ${activeMenu === 'documents' ? 'active' : ''}`}
                        onClick={() => onMenuClick({ 
                            activeMenu: 'documents', 
                            showFinanceView: false, 
                            showStudentDetailsView: false 
                        })}
                    />
                </div>

                <div className="menu-item">
                    <Button
                        label="Add Appointment"
                        className={`p-button-text menu-button ${activeMenu === 'addAppointment' ? 'active' : ''}`}
                        onClick={() => onMenuClick({ 
                            activeMenu: 'addAppointment', 
                            showFinanceView: false, 
                            showStudentDetailsView: false 
                        })}
                    />
                </div>

                <div className="menu-item">
                    <Button
                        label="Concerns"
                        className={`p-button-text menu-button ${activeMenu === 'concerns' ? 'active' : ''}`}
                        onClick={() => onMenuClick({ 
                            activeMenu: 'concerns', 
                            showFinanceView: false, 
                            showStudentDetailsView: false 
                        })}
                    />
                </div>

                <div className="menu-item">
                    <Button
                        label="Access Restriction"
                        className={`p-button-text menu-button ${activeMenu === 'accessRestriction' ? 'active' : ''}`}
                        onClick={() => onMenuClick({ 
                            activeMenu: 'accessRestriction', 
                            showFinanceView: false, 
                            showStudentDetailsView: false 
                        })}
                    />
                </div>

                <div className="menu-item">
                    <Button
                        label="Student Profile Album"
                        className="p-button-text menu-button"
                    />
                </div>
            </div>
        </div>
    );
};

export default StudentNavigation;
